<div>
    <div class="modal-header">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg" style="display: flex; align-items: center">
                    <img class="modal-icon" style="width: 35px;" src="assets/ico/jira-brands.svg" alt="icon">
                    <span class="modal-title" id="modal-basic-title">
                        <span *ngIf="!currentSection"> {{ 'order.budget.project.title' | translate }} </span>
                        <span *ngIf="currentSection === 'linkNewProject'"> {{ 'order.budget.project.linkNewProject' |
                            translate }} </span>
                        <span *ngIf="currentSection === 'linkExistingProject'"> {{
                            'order.budget.project.linkExistingProject' | translate }} </span>
                        <span *ngIf="currentSection === 'migrateProject'"> {{
                            'order.budget.project.migrateProject' | translate }} </span>
                    </span>
                </div>
                <div class="modal-icon icon fill-white close-icon" (click)="close(null)" aria-label="close"
                    [inlineSVG]="'assets/ico/close-24px.svg'"></div>
            </div>
        </div>
    </div>
    <div class="modal-body mb-5">
        <div id="picker" *ngIf="!currentSection">
            <div class="row" *ngIf="!projectId">
                <div class="col-lg-6">
                    <apc-pick-card [title]="'order.budget.project.linkNewProject'"
                        [description]="'order.budget.project.linkNewProjectDescription' | translate"
                        [image]="'assets/ico/crea-progetto.svg'" [id]="'linkNewProject'"
                        (selectSectionEvent)="selectSection($event)">
                    </apc-pick-card>
                </div>
                <div class="col-lg-6">
                    <apc-pick-card [title]="'order.budget.project.linkExistingProject'"
                        [description]="'order.budget.project.linkExistingProjectDescription' | translate"
                        [image]="'assets/ico/seleziona-progetto.svg'" [id]="'linkExistingProject'"
                        (selectSectionEvent)="selectSection($event)">
                    </apc-pick-card>
                </div>
            </div>
            <div class="row" *ngIf="projectId">

                <div class="col-lg-6">
                    <apc-pick-card [title]="'order.budget.project.unlinkProject'" (click)="unLinkProject()"
                        [description]="'order.budget.project.unlinkProjectDescription' | translate"
                        [image]="'assets/ico/detach.svg'" [id]="'unlinkProject'" [route]="'route'">
                    </apc-pick-card>
                </div>

                <div class="col-lg-6">
                    <apc-pick-card [title]="'order.budget.project.migrateProject'"
                        [description]="'order.budget.project.migrateProjectDescription' | translate"
                        [image]="'assets/ico/migrate.svg'" [id]="'migrateProject'" [route]="'route'"
                        (selectSectionEvent)="selectSection($event)">
                    </apc-pick-card>
                </div>
            </div>
        </div>
        <apc-new-order-budget-project *ngIf="currentSection === 'linkNewProject'" (backEvent)="currentSection = null"
            [budgetId]="budgetId" [budget]="budget" (operationSuccess)="close($event)"></apc-new-order-budget-project>
        <apc-link-existing-project *ngIf="currentSection === 'linkExistingProject'" (backEvent)="currentSection = null"
            [budgetId]="budgetId" (operationSuccess)="close($event)"></apc-link-existing-project>
        <apc-order-migrate-project *ngIf="currentSection === 'migrateProject'" (backEvent)="currentSection = null" (closeEventEmitter)="close($event)" [budgets]="budgets" [orderName]="orderName"
            [budgetId]="budgetId" [projectId]="projectId" [budgetName]="budget.name" [budget]="budget" [projectName]="budget.project.name" (operationSuccess)="close($event)" (hideModalEvent)="hideMainModal()" (showModalEvent)="showMainModal()" >
        </apc-order-migrate-project>
    </div>
</div>